var exports = {
  "kL": "xe533113f--9e5d2c--container",
  "rf": "xe533113f--9e5d2c--body",
  "Qq": "xe533113f--9e5d2c--text",
};

module.exports = exports;
